<div class="mat-elevation-z5">
  <mat-toolbar color="primary">
    <mat-icon svgIcon="calculator"></mat-icon>
    <h1 class="mat-title">BPM Calculator</h1>
    <div class="uf-filler"></div>
    <button mat-icon-button (click)="dialogRef.close()">
      <mat-icon svgIcon="close"></mat-icon>
    </button>
  </mat-toolbar>
  <div class="p-8">
    <form [formGroup]="calcForm" (submit)="onSubmit()">
      <div class="car-info-row">
        <mat-form-field>
          <mat-label>Kenteken</mat-label>
          <input matInput type="text" formControlName="vrn"/>
        </mat-form-field>
        <div class="uf-car-info">
          {{vehicle.brand}} {{vehicle.model}}<br/>{{vehicle.type}}
        </div>
      </div>
      <mat-form-field>
        <mat-label>BTW</mat-label>
        <mat-select formControlName="vatId">
          @for (vat of vatList; track vat.id) {
            <mat-option [value]="vat.id">
              {{vat.description}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <div>
        <mat-form-field>
          <mat-label>Datum afgifte</mat-label>
          <input matInput [matDatepicker]="myDatepicker" formControlName="firstAdmissionDate">
          <mat-datepicker-toggle matSuffix [for]="myDatepicker"></mat-datepicker-toggle>
          <mat-datepicker #myDatepicker></mat-datepicker>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Verkoop/Inkoop datum</mat-label>
          <input matInput [matDatepicker]="salesDatepicker" formControlName="date">
          <mat-datepicker-toggle matSuffix [for]="salesDatepicker"></mat-datepicker-toggle>
          <mat-datepicker #salesDatepicker></mat-datepicker>
        </mat-form-field>
      </div>
      <mat-form-field>
        <mat-label>Inclusief</mat-label>
        <input matInput type="number" formControlName="inclusive"/>
      </mat-form-field>
      <button mat-button mat-raised-button color="primary" type="submit">Bereken</button>
    </form>
    <div>
      <table>
        <tr>
          <td width="175">Exclusief</td>
          <td align="right">{{result.exclusive | number: '1.2-2'}}</td>
        </tr>
        <tr>
          <td>Btw</td>
          <td align="right">{{result.vatAmount | number: '1.2-2'}}</td>
        </tr>
        <tr>
          <td>BPM {{result.bpmPercentage}}%</td>
          <td align="right">{{result.bpmAmount | number: '1.2-2'}}</td>
        </tr>
        <tr>
          <td>Inclusief</td>
          <td align="right">{{result.inclusive | number: '1.2-2'}}</td>
        </tr>
      </table>
    </div>
  </div>
</div>




